import {PRISMAX_BACKEND_URL} from '../configs/config';

function authHeaders(token) {
    const headers = {'Content-Type': 'application/json'};
    if (token) {
        headers.Authorization = `Bearer ${token}`;
    }
    return headers;
}

async function readError(response) {
    let detail;
    try {
        const data = await response.json();
        detail = data && (data.msg || data.message || data.detail || data.error);
    } catch (_e) {
        // ignore
    }
    return detail || `Request failed (${response.status})`;
}

export async function fetchHexCapabilityRequests({
    token,
    status = 'pending',
    page = 1,
    signal,
} = {}) {
    const params = new URLSearchParams({
        status: status || 'pending',
        page: String(page || 1),
    });
    const response = await fetch(
        `${PRISMAX_BACKEND_URL}/api/vla-admin/hex-capability-requests?${params.toString()}`,
        {headers: authHeaders(token), signal},
    );
    if (!response.ok) {
        throw new Error(await readError(response));
    }
    return response.json();
}

export async function downloadHexCapabilityRequestsExcel({
    token,
    status = 'pending',
    signal,
} = {}) {
    const params = new URLSearchParams({
        status: status || 'pending',
    });
    const headers = {};
    if (token) {
        headers.Authorization = `Bearer ${token}`;
    }
    const response = await fetch(
        `${PRISMAX_BACKEND_URL}/api/vla-admin/hex-capability-requests/export?${params.toString()}`,
        {headers, signal},
    );
    if (!response.ok) {
        throw new Error(await readError(response));
    }
    const blob = await response.blob();
    const disposition = response.headers.get('Content-Disposition') || '';
    const match = disposition.match(/filename="?([^";]+)"?/i);
    const fileName = match?.[1] || `hex-capability-requests-${status || 'pending'}.xlsx`;
    const downloadUrl = window.URL.createObjectURL(blob);
    const anchor = document.createElement('a');
    anchor.href = downloadUrl;
    anchor.download = fileName;
    document.body.appendChild(anchor);
    anchor.click();
    anchor.remove();
    window.setTimeout(() => window.URL.revokeObjectURL(downloadUrl), 1000);
}

export async function fetchHexSessionChatLogs({
    token,
    sessionId,
    limit = 400,
    signal,
} = {}) {
    if (!sessionId) {
        throw new Error('Missing Hex session id');
    }
    const params = new URLSearchParams({limit: String(limit || 400)});
    const response = await fetch(
        `${PRISMAX_BACKEND_URL}/api/vla-admin/hex-sessions/${encodeURIComponent(sessionId)}/chat-logs?${params.toString()}`,
        {headers: authHeaders(token), signal},
    );
    if (!response.ok) {
        throw new Error(await readError(response));
    }
    return response.json();
}
